import { useCartContext } from "app/providers/CartProvider";
import { toast } from "react-toastify";
import Icon, { IconTypes } from "shared/ui/icon";
import { Delete } from "shared/ui/icons/Delete";
import Text from "shared/ui/typography/Text";
import { getProductEditLink } from "./getProductEditLink";

interface CheckoutProductControlsProps {
  index: number;
  hideEditButton?: boolean;
}

const CheckoutProductControls = ({
  index,
  hideEditButton = false,
}: CheckoutProductControlsProps) => {
  const cart = useCartContext();

  const onRemoveClick = () => {
    toast.success("Product verwijderd");
    cart.removeCartProduct(index);
  };

  return (
    <div className="gg-flex gg-justify-center gg-gap-x-5 gg-text-xs gg-underline md:gg-gap-x-10 md:gg-text-sm lg:gg-grid lg:gg-justify-between lg:gg-gap-y-5">
      {!hideEditButton && (
        <button
          className="gg-flex gg-items-center"
          onClick={() =>
            (window.location.href = getProductEditLink(cart, index))
          }
        >
          <Icon name={IconTypes.EDIT} className="gg-mr-2.5" />
          <Text className="gg-text-left">Pas ontwerp aan</Text>
        </button>
      )}
      <button
        className="gg-flex gg-items-center"
        onClick={() => cart.duplicateCartProduct(index)}
      >
        <Icon name={IconTypes.DUPLICATE} className="gg-mr-2.5" />
        <Text className="gg-text-left">Dupliceren</Text>
      </button>
      <button
        data-testid="remove-door-from-cart"
        className="gg-group gg-flex gg-items-center"
        onClick={() => onRemoveClick()}
      >
        <Delete className="gg-mr-2.5 gg-fill-red group-hover:gg-fill-red-700" />
        <Text className="gg-text-left gg-text-red gg-underline group-hover:gg-text-red-700">
          Verwijderen
        </Text>
      </button>
    </div>
  );
};
export default CheckoutProductControls;
